import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-study-center-details',
  templateUrl: './study-center-details.component.html',
  styleUrls: ['./study-center-details.component.css']
})
export class StudyCenterDetailsComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

}
